/**
 * Created by tdunham on 10/9/2017.
 */

export class RssmanagerItem {


	public id: number;              // ID value in the Angular ReST API table.
	public url: string;             // The URL stub used to retrieve this item.
	public title: string;           // A label for the item.
	public player_id: string;       // The field name to use when displaying the player ID.
	public team_id: string;         // The field name to use when displaying the team ID.
	public code: string;            // The sport the player is in ('NFL', 'MLB', etc.)
	public categories: string;      // Which categories are up for possible listing on export of this item.
	public display: string;         // Which of the two display types to use: 'Stats Display' or 'Standard KFFL'.
	public is_active: string;       // Whether this is available or not. ('Yes' or 'No')
	public limit: number;           // How many items to display.
	public output: string;          // Is this an XML or JSON feed? ('XML' or 'JSON')


	constructor( values: Object = {} ) {
		Object.assign( this, values );
	}

}



// WEBPACK FOOTER //
// ./src/app/services/feed/rssmanageritem.ts